<template>
    <div class="slot-item" :class="{ 'has-slot': currentSlot, 'no-slot': !currentSlot }">
        <div class="slot-content">
            <div class="slot-info">
                <div class="slot-label">Regalfach</div>
                <div class="slot-value">{{ currentSlot || 'Kein Fach bereit' }} - {{ currentOrderId }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SlotItem',
    props: {
        currentSlot: {
            type: String,
            default: null
        },
        currentOrderId: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>
.slot-item {
    background: #121212;
    border: 2px solid #333;
    border-radius: 8px;
    padding: 8px 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.slot-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.slot-item.has-slot {
    border-color: #121212;
    background: #121212;
}

.slot-item.no-slot {
    border-color: #098c00;
    background: #098c00;
}

.slot-content {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.slot-info {
    flex: 1;
    min-width: 0;
}

.slot-label {
    font-size: 9px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.slot-value {
    font-size: 18px;
    font-weight: 700;
    color: white;
    margin: 2px 0 0 0;
    font-family: 'Monaco', 'Consolas', monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .slot-item {
        padding: 10px;
    }
    
    .slot-content {
        gap: 6px;
    }
    
    .slot-label {
        font-size: 10px;
    }
    
    .slot-value {
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .slot-item {
        padding: 8px;
    }
    
    .slot-label {
        font-size: 9px;
    }
    
    .slot-value {
        font-size: 13px;
    }
    
    .slot-status-chip {
        font-size: 9px !important;
    }
}
</style>